import React from "react";
import { QueryClientProvider } from "react-query";
import { Redirect } from "react-router";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { MainLayout } from "../components";
import { FieldRoutes } from "../features/fields";
import FieldProvider from "../features/fields/providers/FieldProvider";
import LayerProvider from "../features/fields/providers/LayerProvider";
import LayerProviderSoilsView from "../features/fields/providers/LayerProviderSoilsView";
import { PlantRoutes } from "../features/plants/routes/PlantRoutes";
import { SoilRoutes } from "../features/soils/routes/SoilRoutes";
import { queryClient } from "../utils/reactQuery";

export const ProtectedRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <QueryClientProvider client={queryClient}>
            <MainLayout>
                <Switch>
                    <Switch>
                        <Route path={`${path}/:vp/fields`}>
                            <FieldProvider>
                                <LayerProvider>
                                    <FieldRoutes />
                                </LayerProvider>
                            </FieldProvider>
                        </Route>
                        <Route path={`${path}/:vp/plants`}>
                            <FieldProvider>
                                <LayerProvider>
                                    <PlantRoutes />
                                </LayerProvider>
                            </FieldProvider>
                        </Route>
                        <Route path={`${path}/:vp/soils`}>
                            <FieldProvider>                                
                                <LayerProviderSoilsView>
                                        <SoilRoutes /> 
                                </LayerProviderSoilsView>
                            </FieldProvider>
                        </Route>
                        <Route path={`${path}`}>
                            <Redirect to={`${path}/@/fields`} />
                        </Route>
                        <Route path={`${path}/plants`}>
                            <Redirect to={`${path}/@/plants`} />
                        </Route>
                        <Route path={`${path}/soils`}>
                            <Redirect to={`${path}/@/soils`} />
                        </Route>
                    </Switch>
                </Switch>
            </MainLayout>
        </QueryClientProvider>
    );
}
